'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = 'M240 0l-112 0 0 272-79.6 49.8C18.3 340.6 0 373.6 0 409.1l0 4.7c0 54.3 44 98.3 98.3 98.3 14.3 0 28.4-3.1 41.3-9.1-9.5-12.8-16.8-27.3-21.6-42.9-6.2 2.6-12.9 4-19.7 4-27.8 0-50.3-22.5-50.3-50.3l0-4.7c0-18.9 9.8-36.6 25.8-46.6 62.6-39.1 96.6-60.4 102.2-63.9l0-154.6 64 0 0-48-64 0 0-48 64 0 0-48zm96 144l96 0 0 214.3-145.9 97.3c-8.3 5.5-18 8.4-27.9 8.4-27.8 0-50.3-22.5-50.3-50.3l0-4.7c0-18.9 9.8-36.6 25.8-46.6 62.6-39.1 96.6-60.4 102.2-63.9L336 144zm0-48l0-48 96 0 0 48-96 0zm144 24l0-120-192 0 0 272-79.6 49.8c-30.1 18.8-48.4 51.8-48.4 87.3l0 4.7c0 54.3 44 98.3 98.3 98.3 19.4 0 38.4-5.7 54.5-16.5L480 384 480 120z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;